<script>
export default {
  props: {
    expanded: { type: Boolean, default: true },
    collapsable: { type: Boolean, default: true },
    id: { type: String }
  },
  data() {
    return {
      isExpanded: true
    }
  },
  watch: {
    expanded: function() {
      this.isExpanded = this.expanded
    }
  },
  computed: {
    toggleText() {
      return this.isExpanded ? 'Collapse' : 'Expand'
    }
  },
  methods: {
    toggleCollapseExpand() {
      this.isExpanded = !this.isExpanded
    }
  },
  mounted() {
    this.isExpanded = this.expanded
  }
}
</script>

<template>
  <div class="detailsContainer" :id="id">
    <div class="containerHeader">
      <div class="sectionHeaderTitle"><slot name="header"></slot></div>
      <div
        class="sectionHeaderCollapseButton"
        @click="toggleCollapseExpand"
        v-if="collapsable"
      >
        <b-button variant="link" size="sm">
          {{ toggleText }}
        </b-button>
      </div>
    </div>
    <div :class="{ containerContent: true, hide: !isExpanded }">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<style>
.detailsContainer {
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #000;
  margin: 10px;
}
.detailsContainer .containerHeader {
  color: #fff;
  font-size: 1.2rem;
  padding-left: 15px;
  line-height: 38px;
  height: 40px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background: linear-gradient(180deg, #0b2544 0%, #194173 12.52%, #032548 100%);
}
.detailsContainer .containerContent {
  color: #000;
  font-size: 1.1rem;
  padding-top: 10px;
  padding-bottom: 15px;
}
.detailsContainer .containerContent label {
  margin-bottom: 0px;
}
.detailsContainer .containerContent .row {
  margin-bottom: 5px;
}
.detailsContainer .sectionHeaderTitle {
  float: left;
  padding-right: 10px;
}
.detailsContainer .sectionHeaderButtons {
  position: relative;
  top: -1px;
}
.detailsContainer .sectionHeaderCollapseButton {
  float: right;
  margin-right: 10px;
}
.detailsContainer .sectionHeaderCollapseButton button,
.detailsContainer .sectionHeaderCollapseButton button:link,
.detailsContainer .sectionHeaderCollapseButton button:visited {
  color: #fff;
  text-decoration: none;
}
.detailsContainer .sectionHeaderCollapseButton button:active,
.detailsContainer .sectionHeaderCollapseButton button:hover {
  color: #fff;
  text-decoration: underline;
}
</style>
